import React, { ReactNode } from 'react'

// Components
import LiveList from '@/components/shared/LiveList'

import Empty from '@/components/shared/Empty'

// Constants
import { GTM_LOCATION } from '@/constants/gtmEvent'

const VirtualizedLives = ({ liveListData, title }: { liveListData: any; title?: ReactNode }) => {
  return (
    <div>
      {title}
      {/* 若沒資料的話rooList會是null */}
      {liveListData?.data?.pages[0].roomList?.length > 0 ? <LiveList liveListData={liveListData} gtmLocation={GTM_LOCATION.INDEX} /> : <Empty />}
    </div>
  )
}

export default VirtualizedLives
